export default __webpack_public_path__ + "img/b0c6f377f0956d39f27a47b2a000f5f0.svg";